import Layout from "../../components/layout/Layout";
import { useTranslation } from "react-i18next";
import {  useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import i18n from "../../i18n";
import SeoHead from "../../components/elements/SeoHead";
const PublicOfferRu = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        const handleLanguageChange = () => {
          navigate(`/${i18n.language}/public-offer`)
        };
    
        i18n.on("languageChanged", handleLanguageChange);
        return () => {
          i18n.off("languageChanged", handleLanguageChange);
        };
      }, []);
    return (
        <Layout headerStyle={1} footerStyle={2} >
            <SeoHead metaKey="seo.publicOffer" />
            <div className="container" style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 30 }}>
                <h2 style={{ textTransform: "none", marginBottom:20 }}>Публичный договор оферты на предоставление услуг по управлению проектами через платформу SkTech</h2>
                <p>Этот документ является публичной офертой и публичным договором, адресованным пользователям для заключения договора на предоставление услуг по управлению проектами через платформу SkTech (далее – «Платформа»). Пользуясь Платформой и осуществляя оплату подписки, Пользователь автоматически принимает условия этого Договора.</p>
                <p>Согласно положениям ст. 633, 641 Гражданского кодекса Украины условия публичной оферты и публичного договора одинаковы для всех пользователей. В соответствии с ч. 2 ст. 642 Гражданского кодекса Украины регистрация на платформе SkTech (https://sk-tech.ai) является акцептом этой оферты, что приравнивается к заключению договора на условиях, изложенных ниже, а также в соответствии с Политикой конфиденциальности. Политика конфиденциальности регулирует обработку персональных данных пользователей. Ознакомиться с условиями Политики конфиденциальности можно по ссылке на нашей платформе. Политика конфиденциальности является неотъемлемой частью этих условий.</p>

                <h3>1. Общие положения</h3>
                <p>1.1. Этот Договор регулирует отношения между Платформой SkTech ООО «САНПОИНТ АЙ-ТИ СОЛЮШНС» (далее – «Администрация») и пользователем (далее – «Пользователь»), которые заключаются на основе акцепта оферты.</p>
                <p>1.2. Этот Договор является официальным предложением Администрации для заключения договора на условиях, изложенных ниже.</p>
                <p>1.3. Использование Платформы означает полное согласие Пользователя со всеми условиями Договора.</p>

                <h3>2. Предмет договора</h3>
                <p>2.1. Администрация предоставляет Пользователю доступ к платформе для управления проектами (далее – «Сервис») на условиях подписки, а Пользователь обязуется оплатить соответствующую стоимость.</p>
                <p>2.2. Доступ к Сервису предоставляется в обмен на оплату выбранной подписки: ежемесячной или годовой.</p>

                <h3>3. Порядок заключения договора</h3>
                <p>3.1. Договор считается заключенным с момента акцепта Пользователем оферты путем осуществления оплаты подписки на Платформе.</p>
                <p>3.2. Принятие (акцепт) оферты означает полное и безусловное принятие всех условий Договора без каких-либо исключений.</p>

                <h3>4. Права и обязанности сторон</h3>
                <ul style={{ paddingLeft: "2rem" }}>
                    <li style={{ paddingBottom: 10 }}><strong>4.1. Обязанности Администрации:</strong>
                        <ul>
                            <li>Предоставлять доступ к платформе для управления проектами в соответствии с выбранной подпиской;</li>
                            <li>Обеспечивать надлежащее техническое состояние Сервиса для стабильной работы;</li>
                            <li>Отвечать на запросы и решать вопросы, возникающие в процессе использования Сервиса.</li>
                        </ul>
                    </li>
                    <li><strong>4.2. Обязанности Пользователя:</strong>
                        <ul>
                            <li>Соблюдать условия этого Договора и политику конфиденциальности;</li>
                            <li>Предоставлять только достоверную информацию при регистрации;</li>
                            <li>Не передавать свои данные для доступа к Сервису третьим лицам.</li>
                        </ul>
                    </li>
                </ul>

                <h3>5. Стоимость услуг и порядок оплаты</h3>
                <p>5.1. Стоимость подписки публикуется на Платформе в долларах США. Цена в гривнах определяется путем конвертации платежной системой по ее курсу на день оплаты:</p>
                <ul>
                    <li>Тариф «Базовый»: 10 долларов США в месяц или 100 долларов США в год (эквивалент в гривнах — по курсу платежной системы на момент оплаты);</li>
                    <li>Тариф «Комфорт»: 25 долларов США в месяц или 250 долларов США в год (эквивалент в гривнах — по курсу платежной системы на момент оплаты);</li>
                    <li>Тариф «Без границ»: 30 долларов США в месяц или 300 долларов США в год (эквивалент в гривнах — по курсу платежной системы на момент оплаты).</li>
                </ul>
                <p>5.2. Оплата осуществляется через платежную систему, интегрированную на Платформе, и сумма будет конвертирована по курсу платежной системы на день оплаты.</p>
                <p>5.3. Администрация оставляет за собой право изменять стоимость подписки, предварительно уведомив Пользователя через Платформу.</p>

                <h3>6. Порядок возврата средств</h3>
                <p>6.1. В случае технических проблем со стороны Администрации, которые привели к невозможности использования Сервиса, Пользователь может обратиться с запросом на частичный или полный возврат средств.</p>
                <p>6.2. Запрос должен быть подан в течение 14 календарных дней с момента возникновения проблемы.</p>
                <p>6.3. Возврат средств не производится, если Пользователь добровольно прекратил использование Сервиса до окончания срока действия подписки.</p>

                <h3>7. Ответственность сторон</h3>
                <p>7.1. Администрация не несет ответственности за убытки, возникшие из-за:</p>
                <ul>
                    <li>Некорректного использования Сервиса Пользователем.</li>
                    <li>Проблем в работе оборудования или программного обеспечения Пользователя.</li>
                    <li>Форс-мажорных обстоятельств.</li>
                </ul>
                <p>7.2. Пользователь несет ответственность за достоверность информации, предоставленной при регистрации.</p>

                <h3>8. Срок действия договора</h3>
                <p>8.1. Договор вступает в силу с момента оплаты подписки и действует в течение выбранного периода (месяц или год).</p>
                <p>8.2. После завершения срока подписки Пользователь может продлить действие договора, осуществив оплату следующего периода.</p>

                <h3>9. Другие условия</h3>
                <p>9.1. Администрация имеет право изменять условия Договора. Изменения вступают в силу с момента их публикации на Платформе.</p>
                <p>9.2. Продолжение использования Сервиса после внесения изменений означает согласие Пользователя с такими изменениями.</p>

                <h3>10. Контактная информация</h3>
                <p>ООО «САНПОИНТ АЙ-ТИ СОЛЮШНС»</p>
                <p>Код ЕДРПОУ: 42783354</p>
                <p>Адрес: ул. Серповая, 11, г. Киев, Украина</p>
                <p>Email: sktech@sunpoint.com.ua</p>

                <p>Этот Договор является публичным, бессрочным, и остается действительным до момента его отзыва Администрацией.</p>
            </div>


        </Layout>
    )
}
export default PublicOfferRu;